import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting/user-types";

export default {
  getUserType(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getListOfUserType(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createUserType(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteUserType(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateUserType(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
